__turbopack_context__.v({
  "activeBtn": "styles-module__iRL1lG__activeBtn",
  "authHead": "styles-module__iRL1lG__authHead",
  "headerBtn": "styles-module__iRL1lG__headerBtn",
  "wrapper": "styles-module__iRL1lG__wrapper",
});
